module.exports = __webpack_public_path__ + "img/selected4-min.c7e9f1d4.png";